import Logo from "../../components/ui/Logo";

function AdminLogin({ onLogin }) {
  return (
    <section className="page-section">
      <div className="shell">
        <div className="mx-auto max-w-md">
          <div className="mb-8 flex justify-center">
            <Logo />
          </div>
          <form className="card p-6">
            <h1 className="text-2xl font-extrabold tracking-tight text-white">Prihlaseni do administrace</h1>
            <p className="mt-2 text-sm leading-6 text-slate-300">
              Interni sprava zakazek, faktur a kalendare.
            </p>

            <div className="mt-6 grid gap-4">
              <label className="grid gap-1.5 text-sm font-medium text-slate-200">
                E-mail
                <input className="input" defaultValue="admin@eltt.cz" />
              </label>
              <label className="grid gap-1.5 text-sm font-medium text-slate-200">
                Heslo
                <input className="input" type="password" defaultValue="demo-admin" />
              </label>
              <button type="button" onClick={onLogin} className="btn-primary w-full">
                Prihlasit
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default AdminLogin;
